import { render, staticRenderFns } from "./BooleanSelect.vue?vue&type=template&id=b3b80412&"
import script from "./BooleanSelect.vue?vue&type=script&lang=js&"
export * from "./BooleanSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports